import React, {useEffect, useMemo} from 'react';
import {Box, HStack, VStack} from "native-base";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";
import Note from "../../../../../../svg/Note";
import {Colors} from "../../../../../../styles/Colors";
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {isRTL, t} from "../../../../../../services/i18n";
import InfoTooltip from "../../../../../common/InfoTooltip";
import {useDispatch, useSelector} from "react-redux";
import {htmlToPlainText, isMobile} from "../../../../../../services/Helpers";
import {CREATE_EVENT_MODAL, openModal, STEPPER_CONFIRM_MODAL} from "../../../../../../redux/modalManagerSlice";
import {flowOptions} from "../FlowOptions";
import {openStepperModal} from "../../../../../../services/stepperService";
import {Tooltip} from "antd";
import usePermissions from "../../../../../../services/Permissions";
import '../../../../../common/AntUI.scss'
import {SERIES_FUTURE_SESSIONS_EDIT_TYPE, SINGLE_SESSION_EDIT_TYPE} from "../../../../../../services/ConstHelper";

const NoteSection = (props) => {
    const { values, setFieldValue, scheduleType, isAppointment} = props;
    const editType = useSelector(state => state.stepper?.editType);
    const createEventModalRes = useSelector(state => state.modalManager.createEventModal.processRes)
    const targetNote = useMemo(() => editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE ? values?.scheduleTarget?.series?.series_note_relation : values?.scheduleTarget?.scheduleNote, [values?.scheduleTarget]);
    const dispatch = useDispatch()
    const { has } = usePermissions()

    useEffect(() => {
        if(createEventModalRes?.flowName === flowOptions.SCHEDULE_NOTE) {
            setFieldValue('noteConfig', createEventModalRes.values)
        }
    }, [createEventModalRes]);


    //this is hell, i know, i am very sorry
    const getContent = () => {
        if (editType) {
            if(values.noteConfig) {
                if(values.noteConfig?.actionType === 'delete') {
                    return <div style={{opacity: '50%'}}><Tooltip title={t('disabled-deleted-note-tooltip')}>{renderCreateNoteBanner({isHovered: false, created: t('deleted-note-from-event')})}</Tooltip></div>
                } else {
                    return renderCreateNote()
                }
            } else {
                if (targetNote) {
                    return (
                        <VStack space={'0.3rem'} overflow={'hidden'} flex={1} padding={'1rem'} style={{border: `1px solid ${Colors.borderColor}`}} borderRadius={'4px'}>
                            <HStack space={'1rem'} justifyContent={'end'}>
                                {has('scheduleNoteEdit') && <CustomButtonV2 tooltipText={t('edit')} type={'link'} iconName={'fa-pen'} onClick={onEditClick}/>}
                                {has('scheduleNoteDelete') && <CustomButtonV2 tooltipText={t('delete')} type={'link'} iconName={'fa-trash-can'} onClick={onDeleteClick}/>}
                            </HStack>
                            <div className={'note-edit-event'} dangerouslySetInnerHTML={{__html: values.noteConfig?.text ?? targetNote.text}}/>
                        </VStack>
                    )
                } else {
                    return renderCreateNote()
                }
            }
            return null
        } else {
            return renderCreateNote()
        }
    }

    const renderCreateNote = () => {
        if(values.noteConfig) {
            return <div style={{opacity: '50%'}}><Tooltip title={t('disabled-create-note-tooltip')}>{renderCreateNoteBanner({isHovered: false, created: htmlToPlainText(values.noteConfig.text)})}</Tooltip></div>
        } else {
            return <CustomButtonV2 wrapperStyle={{width: '100%'}} onClick={createNote} override={({isHovered}) => renderCreateNoteBanner({isHovered, created: null})}/>
        }
    }

    const renderCreateNoteBanner = ({isHovered, created}) => {
        return (
            <HStack borderRadius={'4px'} borderWidth={'1px'} borderStyle={'solid'}
                    borderColor={isHovered && !created ? Colors.newDesign.mainBlue : Colors.borderColor}
                    padding={'0.7rem'} space={'0.7rem'} width={'inherit'} alignItems={'center'}>
                <Box padding={'0.5rem'} bg={Colors.newDesign.tableBackgroundColor}
                     borderRadius={'50%'} width={'34px'} height={'34px'}><Note/></Box>
                <span style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', textWrap: 'nowrap'}}>
                    {created ?? t(`add-note-from-create-event${isMobile ? '-mobile' : ''}`)}
                </span>
            </HStack>
        )
    }

    const createNote = () => {
        openStepperModal({
            modalName: CREATE_EVENT_MODAL,
            props: {
                initSelection: flowOptions.SCHEDULE_NOTE,
                initProps: getCreateOrEditNoteInitProps('create'),
            },
            dispatch,
        })
    }

    const onEditClick = () => {
        openStepperModal({
            modalName: CREATE_EVENT_MODAL,
            props: {
                initSelection: flowOptions.SCHEDULE_NOTE,
                target: targetNote,
                initProps: getCreateOrEditNoteInitProps('edit'),
            },
            dispatch,
        })
    }

    const getCreateOrEditNoteInitProps = (actionType) => {
        return {
            scheduleType: scheduleType ?? values?.scheduleTarget?.box_categories?.name ?? null,
            returnValue: true,
            fromCreateEvent: editType === null,
            isSingle: editType === null ? null : (editType === SINGLE_SESSION_EDIT_TYPE),
            scheduleTarget: values?.scheduleTarget,
            isAppointment,
            editType,
            actionType
        }
    }

    const onDeleteClick = () => {
        dispatch(openModal({modalName: STEPPER_CONFIRM_MODAL, props: {
                header: t('areYouSure'),
                subheader: t('delete-note-from-event-confirm'),
                confirmText: t('confirmDeletingFromEvent'),
                cancelText: t('noKeepIt'),
                onConfirm: () => setFieldValue('noteConfig', {editType: editType, schedule_id: values.scheduleTarget.id, series_id: values.scheduleTarget.series_fk, actionType: 'delete'}),
            }}))
    }

    return (
        <VStack space={'0.2rem'}>
            <HStack>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('note-manage')}</AppText>
                <InfoTooltip title={t('create-note-from-event-tooltip')}/>
            </HStack>
            {getContent()}
        </VStack>
    )

};

export default NoteSection;